/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-authors" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-authors" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-authors" */ `./edit.vue` );

export default {
	path: `authors`,
	children: [
		{
			path: ``,
			name: `list-authors`,
			component: List,
			meta: {
				title: `Authors`
			}
		},
		{
			path: `new`,
			name: `add-author`,
			component: Add,
			meta: {
				title: `Add Author`
			}
		},
		{
			path: `:uuid`,
			name: `edit-author`,
			component: Edit,
			meta: {
				title: `Edit Author`
			}
		}
	]
};
